import React from 'react';
import { appRoutes } from 'routes';
import { useTranslation } from 'react-i18next';
import { isAdminUser } from 'utils';
import { withRouter } from 'react-router-dom';
import * as PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-regular-svg-icons';

export const MobileMenuUserProfile = withRouter(({ username, goToUrl, location }) => {
  const { t } = useTranslation();
  return (
    <ul className="ct-mobile-menu__list">
      <li className="ct-mobile-menu__list-elem ct-mobile-menu__list-elem--user">
        {username}
        <FontAwesomeIcon icon={faUser} />
      </li>

      {isAdminUser() && (
        <li
          className="ct-mobile-menu__list-elem ct-mobile-menu__list-elem--profile-link"
          
        >
          <button
            className="ct-mobile-menu__button"
            onClick={() => {
              goToUrl(appRoutes.administration);
            }}
          >
            {t('administration')}
          </button>
        </li>
      )}

      <li
        data-e2e="mobile-nav-item-my-videos"
        className={`ct-mobile-menu__list-elem ct-mobile-menu__list-elem--profile-link${
          location.pathname === '/my-videos' ? ' ct-mobile-menu__list-elem--active' : ''
        }`}
      >
        <button
          className="ct-mobile-menu__button"
          onClick={() => goToUrl('/my-videos')}
        >
          {t('my_uploads')}
        </button>
      </li>

      <li
        data-e2e="mobile-nav-item-favourites"
        className={`ct-mobile-menu__list-elem ct-mobile-menu__list-elem--profile-link${
          location.pathname.indexOf('/saved-videos') !== -1 ? ' ct-mobile-menu__list-elem--active' : ''
        }`}
      >
        <button
          className="ct-mobile-menu__button"
          onClick={() => goToUrl('/saved-videos/1/?sort=recently_added')}
        >
          {t('saved_uploads')}
        </button>
      </li>
    </ul>
  );
});

MobileMenuUserProfile.propTypes = {
  username: PropTypes.string,
  goToUrl: PropTypes.func,
};
